import { render } from "./AposInputOembed.vue?vue&type=template&id=2968f2c3&scoped=true"
import script from "./AposInputOembed.vue?vue&type=script&lang=js"
export * from "./AposInputOembed.vue?vue&type=script&lang=js"

import "./AposInputOembed.vue?vue&type=style&index=0&id=2968f2c3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2968f2c3"],['__file',"oembed-field/ui/apos/components/AposInputOembed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2968f2c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2968f2c3', __exports__)) {
    api.reload('2968f2c3', __exports__)
  }
  
  module.hot.accept("./AposInputOembed.vue?vue&type=template&id=2968f2c3&scoped=true", () => {
    api.rerender('2968f2c3', render)
  })

}


export default __exports__